import { Feature } from 'utils/feature'

export const FirstCallSchedulingExperiment = {
  flag: Feature.ExperimentVideoCallFirstCallSchedulingWindow
} as const

// Experiments wired into the app. Unleash decides which ones are live.
export const EXPERIMENTS = [FirstCallSchedulingExperiment] as const
